import { RouterStore as OrgRouterStore } from "mobx-react-router";
import { withOutLastPart } from "../helpers/route";
import { createContext } from "react";

export class RouterStore extends OrgRouterStore {
  /** Base route (default value: "admin"). Must be a valid route without slashes, otherwise useRouteMatch will return null */
  public homeRoute: string;
  /** Used for IndexView to collect persisted search params */
  private persistedParams: { [k: string]: string };
  /** If true search params will be remembered and on go back to IndexView they will be added to all params */
  private shouldPersistParams: boolean = false;

  public constructor() {
    super();
    this.persistedParams = {};
    this.homeRoute = "admin";
  }

  public goToParent() {
    const pathname = this.location.pathname;
    const newPath = withOutLastPart(pathname);
    this.history.push(newPath);
  }

  public goUpTwice() {
    const pathname = this.location.pathname;
    const newPath = withOutLastPart(pathname);
    this.history.push(withOutLastPart(newPath));
  }

  /** Home route value override, must be used right after mainStore initialization e.g. inside App.tsx */
  public overrideHomeRoute(routeName: string): void {
    this.homeRoute = routeName;
  }

  /** Allows globally persist search params mechanism for all IndexViews */
  public applyPersistParams() {
    this.shouldPersistParams = true;
  }

  /** Used for IndexView to persist search params in "memory history" */
  public persistQueryParams(pathName: string, params: string) {
    if (this.shouldPersistParams) {
      this.persistedParams[pathName] = params;
    }
  }

  /** Used for IndexView to retrieve search params from "memory history" */
  public retrievePersistedParams(pathName: string) {
    if (this.shouldPersistParams) {
      const persistedParams = this.persistedParams[pathName];
      if (persistedParams) {
        this.history.replace({
          pathname: pathName,
          search: persistedParams
        });
      }
    }
  }
}
export const routerStore = new RouterStore();
export const routerContext = createContext(routerStore);
